<template>
  <div class="containerBackToTopButton">
    <div class="containerBackToTopButton__wrapper desktop" :class="{'visible': scrollY > 350}" @click="scrollToTop">
      <div class="containerBackToTopButton__wrapper--icon"><span class="icon-grey-arrow-up"></span></div>
      <div class="containerBackToTopButton__wrapper--text">Back to top</div>
    </div>
    <div class="containerBackToTopButton__wrapper tablet" :class="{'visible': scrollY > 350}" @click="scrollToTop">
      <div class="containerBackToTopButton__wrapper--icon"><span class="icon-grey-arrow-up"></span></div>
      <div class="containerBackToTopButton__wrapper--text">Back to top</div>
    </div>
    <div class="containerBackToTopButton__wrapper mobile" :class="{'visible': scrollY > 500}" @click="scrollToTop">
      <div class="containerBackToTopButton__wrapper--icon"><span class="icon-grey-arrow-up"></span></div>
      <div class="containerBackToTopButton__wrapper--text">Back to top</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'backToTopButton',
  props: {
    scrollY: {
      type: Number,
      default: null
    }
  },
  emits: ['scroll-to-top'],
  setup (props, { emit }) {

    function scrollToTop() {
      emit('scroll-to-top')
    }

    return {
      scrollToTop
    }
  }
}
</script>
